import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterLink } from '@angular/router';
import { FormsModule } from '@angular/forms';
import { AdminApiService, ClientListItem } from '../services/admin-api.service';

@Component({
  selector: 'app-clients-list',
  standalone: true,
  imports: [CommonModule, RouterLink, FormsModule],
  template: `
    <div class="page">
      <div class="page-header">
        <div>
          <h2>Clientes</h2>
          <p>Gestiona las configuraciones de cada kiosko</p>
        </div>
        <button class="btn btn-primary" (click)="showCreateModal = true">+ Nuevo Cliente</button>
      </div>

      <div class="message success" *ngIf="message">{{ message }}</div>
      <div class="message error" *ngIf="error">{{ error }}</div>

      <div class="clients-grid" *ngIf="clients.length > 0">
        <div class="client-card" *ngFor="let c of clients">
          <div class="card-header">
            <div class="card-color" [style.background]="c.branding_primary_color"></div>
            <div class="card-info">
              <span class="card-code">{{ c.code }}</span>
              <span class="card-status" [class.active]="c.is_active" [class.inactive]="!c.is_active">
                {{ c.is_active ? 'Activo' : 'Inactivo' }}
              </span>
            </div>
          </div>
          <h3>{{ c.client_name }}</h3>
          <p class="card-subtitle">{{ c.client_subtitle }}</p>
          <div class="card-stats">
            <span>🏆 {{ c.leaderboard_count }} records</span>
            <span>📅 {{ c.updated_at | date:'short' }}</span>
          </div>
          <div class="card-actions">
            <a [routerLink]="['/admin/client', c.code]" class="btn btn-sm">Editar</a>
            <button class="btn btn-sm btn-danger" (click)="deleteClient(c.code)">Eliminar</button>
          </div>
        </div>
      </div>

      <div class="empty-state" *ngIf="clients.length === 0 && !loading">
        <span class="empty-icon">📋</span>
        <p>No hay clientes configurados</p>
        <button class="btn btn-primary" (click)="showCreateModal = true">Crear primer cliente</button>
      </div>

      <div class="loading" *ngIf="loading">Cargando...</div>

      <!-- Create Modal -->
      <div class="modal-overlay" *ngIf="showCreateModal" (click)="showCreateModal = false">
        <div class="modal" (click)="$event.stopPropagation()">
          <h3>Nuevo Cliente</h3>
          <div class="form-group">
            <label>Código (ej: ENT01)</label>
            <input [(ngModel)]="newClient.code" placeholder="ENT01" class="input" />
          </div>
          <div class="form-group">
            <label>Nombre</label>
            <input [(ngModel)]="newClient.client_name" placeholder="Entel" class="input" />
          </div>
          <div class="form-group">
            <label>Subtítulo</label>
            <input [(ngModel)]="newClient.client_subtitle" placeholder="Zona de entretenimiento" class="input" />
          </div>
          <div class="modal-actions">
            <button class="btn" (click)="showCreateModal = false">Cancelar</button>
            <button class="btn btn-primary" (click)="createClient()" [disabled]="!newClient.code">Crear</button>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [`
    .page { max-width: 1200px; }

    .page-header {
      display: flex;
      justify-content: space-between;
      align-items: flex-start;
      margin-bottom: 24px;
    }

    .page-header h2 {
      font-size: 24px;
      font-weight: 700;
      color: #1e293b;
      margin: 0;
    }

    .page-header p {
      color: #64748b;
      margin: 4px 0 0;
      font-size: 14px;
    }

    .clients-grid {
      display: grid;
      grid-template-columns: repeat(auto-fill, minmax(320px, 1fr));
      gap: 16px;
    }

    .client-card {
      background: #fff;
      border: 1px solid #e2e8f0;
      border-radius: 12px;
      padding: 20px;
      transition: box-shadow 0.15s;
    }

    .client-card:hover { box-shadow: 0 4px 12px rgba(0,0,0,0.08); }

    .card-header {
      display: flex;
      align-items: center;
      gap: 12px;
      margin-bottom: 12px;
    }

    .card-color {
      width: 40px;
      height: 40px;
      border-radius: 10px;
    }

    .card-info {
      display: flex;
      flex-direction: column;
      gap: 2px;
    }

    .card-code {
      font-weight: 700;
      font-size: 16px;
      color: #1e293b;
      font-family: monospace;
    }

    .card-status {
      font-size: 11px;
      font-weight: 600;
      padding: 2px 8px;
      border-radius: 20px;
      width: fit-content;
    }

    .card-status.active { background: #dcfce7; color: #166534; }
    .card-status.inactive { background: #fee2e2; color: #991b1b; }

    .client-card h3 {
      font-size: 18px;
      font-weight: 600;
      color: #1e293b;
      margin: 0 0 4px;
    }

    .card-subtitle {
      font-size: 13px;
      color: #64748b;
      margin: 0 0 12px;
    }

    .card-stats {
      display: flex;
      gap: 16px;
      font-size: 12px;
      color: #94a3b8;
      margin-bottom: 16px;
    }

    .card-actions {
      display: flex;
      gap: 8px;
    }

    .btn {
      padding: 8px 16px;
      border-radius: 8px;
      border: 1px solid #e2e8f0;
      background: #fff;
      color: #334155;
      font-size: 13px;
      font-weight: 500;
      cursor: pointer;
      text-decoration: none;
      transition: all 0.15s;
    }

    .btn:hover { background: #f1f5f9; }

    .btn-primary {
      background: #4338ca;
      color: #fff;
      border-color: #4338ca;
    }

    .btn-primary:hover { background: #3730a3; }
    .btn-primary:disabled { opacity: 0.5; cursor: not-allowed; }

    .btn-danger {
      color: #dc2626;
      border-color: #fecaca;
    }

    .btn-danger:hover { background: #fef2f2; }

    .btn-sm { padding: 6px 12px; font-size: 12px; }

    .empty-state {
      text-align: center;
      padding: 60px 20px;
      color: #64748b;
    }

    .empty-icon { font-size: 48px; display: block; margin-bottom: 12px; }

    .loading { text-align: center; padding: 40px; color: #94a3b8; }

    .message {
      padding: 12px 16px;
      border-radius: 8px;
      margin-bottom: 16px;
      font-size: 14px;
    }

    .message.success { background: #dcfce7; color: #166534; border: 1px solid #bbf7d0; }
    .message.error { background: #fee2e2; color: #991b1b; border: 1px solid #fecaca; }

    .modal-overlay {
      position: fixed;
      inset: 0;
      background: rgba(0,0,0,0.4);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 1000;
    }

    .modal {
      background: #fff;
      border-radius: 16px;
      padding: 28px;
      width: 420px;
      max-width: 90vw;
    }

    .modal h3 {
      font-size: 20px;
      font-weight: 700;
      margin: 0 0 20px;
      color: #1e293b;
    }

    .form-group {
      margin-bottom: 16px;
    }

    .form-group label {
      display: block;
      font-size: 13px;
      font-weight: 600;
      color: #475569;
      margin-bottom: 6px;
    }

    .input {
      width: 100%;
      padding: 10px 14px;
      border: 1px solid #e2e8f0;
      border-radius: 8px;
      font-size: 14px;
      outline: none;
      box-sizing: border-box;
      transition: border-color 0.15s;
    }

    .input:focus { border-color: #4338ca; box-shadow: 0 0 0 3px rgba(67,56,202,0.1); }

    .modal-actions {
      display: flex;
      gap: 8px;
      justify-content: flex-end;
      margin-top: 24px;
    }
  `]
})
export class ClientsListComponent implements OnInit {
  clients: ClientListItem[] = [];
  loading = true;
  message = '';
  error = '';
  showCreateModal = false;
  newClient = { code: '', client_name: '', client_subtitle: 'Zona de entretenimiento' };

  constructor(private api: AdminApiService) {}

  ngOnInit() {
    this.loadClients();
  }

  loadClients() {
    this.loading = true;
    this.api.getClients().subscribe({
      next: (data: any) => {
        this.clients = data.results || data;
        this.loading = false;
      },
      error: () => {
        this.error = 'Error al cargar clientes. ¿Está corriendo la API?';
        this.loading = false;
      }
    });
  }

  createClient() {
    this.api.createClient(this.newClient).subscribe({
      next: () => {
        this.showCreateModal = false;
        this.message = `Cliente ${this.newClient.code} creado`;
        this.newClient = { code: '', client_name: '', client_subtitle: 'Zona de entretenimiento' };
        this.loadClients();
        setTimeout(() => this.message = '', 3000);
      },
      error: (err) => {
        this.error = 'Error al crear cliente: ' + (err.error?.code?.[0] || err.message);
        setTimeout(() => this.error = '', 5000);
      }
    });
  }

  deleteClient(code: string) {
    if (!confirm(`¿Eliminar cliente ${code}? Esto borrará toda su configuración y records.`)) return;
    this.api.deleteClient(code).subscribe({
      next: () => {
        this.message = `Cliente ${code} eliminado`;
        this.loadClients();
        setTimeout(() => this.message = '', 3000);
      },
      error: (err) => {
        this.error = 'Error al eliminar: ' + err.message;
        setTimeout(() => this.error = '', 5000);
      }
    });
  }
}
